import { render, staticRenderFns } from "./FormThesecreate.vue?vue&type=template&id=6800669e&"
import script from "./FormThesecreate.vue?vue&type=script&lang=js&"
export * from "./FormThesecreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports